import { NgRxUserLibConfig } from '@app/user/models/websocket.model';
import { environment } from 'src/environments/environment';

export const NG_RX_USER_LIB_CONFIG: NgRxUserLibConfig = {
  apiUrl: environment.alertsApiUrl,
  webSocketUrl: environment.webSocketUrl,
};
